<template>
  <div class="flex h-full w-full grow flex-col">
    <SetupApp />
  </div>
</template>

<script setup lang="ts">
</script>
